import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1687771196570'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='8529'
    >
        <path
            d='M729.7024 286.47424l-56.12032 80.54784c33.42336 38.68672 53.7344 89.39008 53.7344 144.9472 0 121.34912-96.6912 219.776-215.97184 219.776-28.55936 0-55.80288-5.69856-80.75776-15.95904l-36.56704 52.48c37.00224 8.00768 76.12928 12.59008 116.93056 12.57984 263.34208 0 448.09216-183.12192 448.09216-268.98944C959.0784 450.38592 871.53152 345.3696 729.7024 286.47424zM312.27904 744.00256l50.57024-72.58112c-41.4976-40.05888-67.42016-96.6656-67.42016-159.44704 0-121.34912 96.63488-219.71968 215.91552-219.71968 35.58912 0 69.13024 8.81152 98.73408 24.32512l39.40352-56.55552c-42.91584-10.65984-89.28768-16.8704-138.53184-16.8704-255.7696 0-448.09216 179.8656-448.09216 268.70784C62.85824 575.6928 161.59744 686.57152 312.27904 744.00256zM510.9504 651.59168c75.95008 0 137.4976-62.65856 137.4976-139.9552 0-28.22656-8.23296-54.47168-22.35904-76.44672l-147.95776 212.36736C488.64768 650.16832 499.6352 651.59168 510.9504 651.59168zM510.9504 371.73248c-75.95008 0-137.4976 62.66368-137.4976 139.9552 0 36.05504 13.39904 68.90496 35.39968 93.70112l155.24352-222.8224C547.74272 375.59808 529.79712 371.73248 510.9504 371.73248zM250.148983 937.341824l-29.574161-20.600281 540.951265-776.600084 29.574161 20.600281-540.951265 776.600084Z'
            fill='currentColor'
            p-id='8530'
        ></path>
    </svg>
)

export const EyesCloseIcon = props => <Icon component={SVG} {...props} />
